define('modules/editor/services/popup_content/index',['require','exports','module','common/models/appstate','../../views/editors/popup'],function (require, exports, module) {
  "use strict";
  var AppState = require("common/models/appstate"),
      PopupEditorView = require("../../views/editors/popup");

  module.exports = {
    editor: {},
    editPopup: function (name, title, text, callback) {

      var popupView = new PopupEditorView({
        name: name,
        title: title,
        content: text
      });
      AppState.setPropsPopUpOpen(true);

      popupView.once("modal:save", function(name, title, content) {
        callback(name, title, content);
        popupView.hide();
        AppState.setPropsPopUpOpen(false);
      });
    }
  };

});

